import React from "react";
import ApexCharts from "react-apexcharts";
import DashboardBarChart from "../../common/DashboardBarChart";
import NoData from "../../common/NoData";
import { getCategoryColors } from "../../../utils/chartTheme";


const CustomHorizontalBarChart = ({ data, otherBreakdown = [] }) => (
  <DashboardBarChart
    horizontal

    allowList={false}
    fold={false}
    items={(data || []).map((item) => ({
      name: item.name,
      count: item.value || 0,
      // "Other/Specify" lists what was specified in its tooltip
      details:
        item.name === "Other/Specify"
          ? otherBreakdown.map((o) => `${o.name}: ${o.value}`)
          : undefined,
    }))}
    unit="businesses"
  />
);


const CustomPieChartB = ({ data, otherBreakdown = [] }) => {
  if (!data || data.length === 0) {
    return <NoData />;
  }

  // Show all labels even if value = 0
  const series = data.map((item) => item.value || 0);
  const labels = data.map((item) => item.name);

  const colorPalette = getCategoryColors(labels);

  const options = {
    chart: {
      type: "pie",
      toolbar: { show: false },
    },
    labels: labels,
    colors: colorPalette,
    dataLabels: {
      enabled: true,
      formatter: (val) => `${val.toFixed(0)}%`,
    },
    plotOptions: {
      pie: {
        dataLabels: { minAngleToShowLabel: 18 },
        expandOnClick: false,
      },
    },
    tooltip: {
      custom: ({ seriesIndex, w }) => {
        const name = w.globals.labels[seriesIndex];
        const value = w.globals.series[seriesIndex];
        let breakdownHtml = "";
        if (name === "Other/Specify" && otherBreakdown.length > 0) {
          breakdownHtml = `<ul style="margin:4px 0 0;padding-left:16px;">${otherBreakdown
            .map((b) => `<li>${b.name}: ${b.value}</li>`)
            .join("")}</ul>`;
        }
        return `<div style="padding:8px 10px;">
          <strong>${name}: ${value}</strong>
          ${breakdownHtml}
        </div>`;
      },
    },
    legend: {
      position: "bottom",
      labels: {
        useSeriesColors: true,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: { width: 300 },
          legend: { position: "bottom" },
        },
      },
    ],
  };

  return (
    <div className="bg-white flex flex-col py-2">
      <div className="flex-1 flex justify-center items-center overflow-hidden">
        <ApexCharts options={options} series={series} type="pie" height={300} />
      </div>
    </div>
  );
};


export default CustomHorizontalBarChart;    
export { CustomPieChartB };        

